import(/* webpackMode: "eager", webpackExports: ["DocPage"] */ "/app/apps/web/src/app/(root)/doc/[docId]/[[...slug]]/DocPage.tsx");
